import { createContext } from "react";

export const WebInformation = createContext(null);
